module.exports = __webpack_public_path__ + "static/keep-team-updates-cb92b54e30d5623c4c0b028e485480f8.png";